import { defineComponent, computed, openBlock, createElementBlock, normalizeClass, createElementVNode, toDisplayString, createCommentVNode, createVNode, unref, createTextVNode, Fragment, renderList, normalizeProps, guardReactiveProps, mergeProps, createBlock } from "vue";
import { IconLocationPinStroke, CdrRating, IconCheckFill, IconXFill } from "@rei/cedar";
import IconThumbsUp from "../../Icons/IconThumbsUp/IconThumbsUp.mjs";
import { EIndividualReviewFeedbackOptions } from "../../../types/pinia/ProductReviewsModel.mjs";
import ProductReviewsSyndicatedBadge from "../ProductReviewsSyndicatedBadge/ProductReviewsSyndicatedBadge.mjs";
import ProductReviewsSyndicatedResponse from "../ProductReviewsSyndicatedResponse/ProductReviewsSyndicatedResponse.mjs";
import ProductReviewsAverageRatingBar from "../ProductReviewsAverageRatingBar/ProductReviewsAverageRatingBar.mjs";
import ProductReviewsImageCarousel from "../ProductReviewsImageCarousel/ProductReviewsImageCarousel.mjs";
const _hoisted_1 = {
  class: "individual-review__name individual-review__text--300",
  "data-ui": "individual-review-author-name"
};
const _hoisted_2 = {
  key: 0,
  class: "individual-review__disclaimer individual-review__text--100",
  "data-ui": "individual-review-badges"
};
const _hoisted_3 = {
  key: 0,
  class: "individual-review__text--200",
  "data-ui": "individual-review-author-location"
};
const _hoisted_4 = {
  key: 0,
  class: "individual-review__header",
  "data-ui": "individual-review-title"
};
const _hoisted_5 = {
  class: "individual-review__submission-time individual-review__text--200",
  "data-ui": "individual-review-submission-time"
};
const _hoisted_6 = {
  key: 1,
  class: "individual-review__review",
  "data-ui": "individual-review-text"
};
const _hoisted_7 = {
  key: 2,
  class: "individual-review__reviewer-info"
};
const _hoisted_8 = {
  key: 0,
  class: "individual-review__user-recommendation individual-review__text--300",
  "data-ui": "individual-review-recommendedation"
};
const _hoisted_9 = {
  key: 0,
  class: "individual-review__user-recommendation--positive",
  "data-ui": "individual-review-recommended"
};
const _hoisted_10 = {
  key: 1,
  class: "individual-review__user-recommendation--negative",
  "data-ui": "individual-review-not-recommended"
};
const _hoisted_11 = {
  key: 3,
  class: "individual-review__review-images"
};
const _hoisted_12 = {
  key: 4,
  class: "individual-review__syndicated",
  "data-ui": "individual-review-syndicated-section"
};
const _hoisted_13 = {
  key: 0,
  class: "individual-review__syndicated-badge"
};
const _hoisted_14 = ["disabled"];
const _hoisted_15 = ["disabled"];
const _hoisted_16 = ["disabled"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "ProductReviewsIndividualReview",
  props: {
    badges: {},
    contextDataValues: {},
    photos: {},
    isModal: {
      type: Boolean
    },
    reportedStatus: {},
    additionalFields: {},
    additionalFieldsOrder: {},
    author: {},
    clientResponses: {},
    dateModified: {},
    id: {},
    isFeatured: {
      type: Boolean
    },
    isRatingsOnly: {
      type: Boolean
    },
    originalProductName: {},
    rating: {},
    reviewId: {},
    secondaryRatings: {},
    secondaryRatingsOrder: {},
    styleId: {},
    submissionId: {},
    submissionTime: {},
    syndicated: {
      type: Boolean
    },
    syndicationDetails: {},
    text: {},
    timeSinceSubmission: {},
    title: {},
    totalFeedbackCount: {},
    totalNegativeFeedbackCount: {},
    totalPositiveFeedbackCount: {},
    userLocation: {},
    videos: {},
    wouldRecommend: {
      type: Boolean
    }
  },
  emits: ["metricsClick", "individualReviewFeedbackClick", "openMapModal"],
  setup(__props, {
    emit: __emit
  }) {
    let EHelpfulValue;
    ((EHelpfulValue2) => {
      EHelpfulValue2[EHelpfulValue2["POSITIVE"] = 0] = "POSITIVE";
      EHelpfulValue2[EHelpfulValue2["NEGATIVE"] = 1] = "NEGATIVE";
      EHelpfulValue2[EHelpfulValue2["NONE"] = 2] = "NONE";
    })(EHelpfulValue || (EHelpfulValue = {}));
    const props = __props;
    const reportedAsInappropriate = computed(() => {
      var _a;
      return ((_a = props.reportedStatus) == null ? void 0 : _a.reported) ?? false;
    });
    const helpfulValue = computed(() => {
      var _a, _b;
      if (((_a = props.reportedStatus) == null ? void 0 : _a.helpful) === EIndividualReviewFeedbackOptions.HELPFUL) {
        return 0;
      }
      if (((_b = props.reportedStatus) == null ? void 0 : _b.helpful) === EIndividualReviewFeedbackOptions.UNHELPFUL) {
        return 1;
      }
      return 2;
    });
    const emit = __emit;
    const openMapModal = (data) => {
      emit("openMapModal", data);
    };
    const onReported = () => {
      const requestBody = {
        feedback: EIndividualReviewFeedbackOptions.REPORT,
        contentId: props.reviewId,
        productId: props.styleId
      };
      emit("metricsClick", {
        linkName: "reviews_report inappropriate"
      });
      emit("individualReviewFeedbackClick", requestBody);
    };
    const onHelpfulVoteClick = (isPositive) => {
      const message = `reviews_helpful vote ${isPositive ? "up" : "down"}`;
      const requestBody = {
        feedback: isPositive ? EIndividualReviewFeedbackOptions.HELPFUL : EIndividualReviewFeedbackOptions.UNHELPFUL,
        contentId: props.reviewId,
        productId: props.styleId
      };
      emit("metricsClick", {
        linkName: message
      });
      emit("individualReviewFeedbackClick", requestBody);
    };
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: normalizeClass({
          "individual-review": !_ctx.isModal,
          "individual-review--modal": _ctx.isModal
        })
      }, [createElementVNode("section", {
        class: normalizeClass({
          "individual-review__information": true,
          "individual-review__information--modal": _ctx.isModal
        })
      }, [createElementVNode("div", _hoisted_1, toDisplayString(_ctx.author.name ?? "Anonymous"), 1), _ctx.badges ? (openBlock(), createElementBlock("div", _hoisted_2, toDisplayString(_ctx.badges), 1)) : createCommentVNode("", true), createElementVNode("div", {
        class: normalizeClass({
          "individual-review__reviewer-stats": !_ctx.isModal,
          "individual-review__reviewer-stats--modal": _ctx.isModal
        })
      }, [_ctx.author.location !== void 0 ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(unref(IconLocationPinStroke)), createTextVNode(" " + toDisplayString(_ctx.author.location), 1)])) : createCommentVNode("", true)], 2)], 2), createElementVNode("section", {
        class: normalizeClass({
          "individual-review__content": true,
          "individual-review__content--modal": _ctx.isModal
        })
      }, [createVNode(unref(CdrRating), {
        rating: _ctx.rating
      }, null, 8, ["rating"]), _ctx.title !== void 0 ? (openBlock(), createElementBlock("h3", _hoisted_4, toDisplayString(_ctx.title), 1)) : createCommentVNode("", true), createElementVNode("div", _hoisted_5, toDisplayString(_ctx.timeSinceSubmission), 1), _ctx.text !== void 0 ? (openBlock(), createElementBlock("p", _hoisted_6, toDisplayString(_ctx.text), 1)) : createCommentVNode("", true), _ctx.contextDataValues.length > 0 || _ctx.wouldRecommend !== void 0 ? (openBlock(), createElementBlock("div", _hoisted_7, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.contextDataValues, (entry) => {
        return openBlock(), createElementBlock("div", {
          key: entry.Id,
          class: "individual-review__info individual-review__text--300",
          "data-ui": "individual-review-context-item"
        }, [createElementVNode("span", null, toDisplayString(entry.DimensionLabel) + ":", 1), createTextVNode(toDisplayString(entry.ValueLabel), 1)]);
      }), 128)), _ctx.wouldRecommend !== void 0 ? (openBlock(), createElementBlock("div", _hoisted_8, [_ctx.wouldRecommend ? (openBlock(), createElementBlock("div", _hoisted_9, [createVNode(unref(IconCheckFill)), _cache[3] || (_cache[3] = createTextVNode(" Yes , I recommend this product "))])) : (openBlock(), createElementBlock("div", _hoisted_10, [createVNode(unref(IconXFill)), _cache[4] || (_cache[4] = createTextVNode(" No, I do not recommend this product "))]))])) : createCommentVNode("", true)])) : createCommentVNode("", true), _ctx.photos.length > 0 && !_ctx.isModal ? (openBlock(), createElementBlock("div", _hoisted_11, [createVNode(unref(ProductReviewsImageCarousel), {
        "review-arr": [{
          ...props
        }],
        "photo-arr": props.photos,
        onOpenMapModal: openMapModal,
        onMetricsClick: _cache[0] || (_cache[0] = (data) => _ctx.$emit("metricsClick", data))
      }, null, 8, ["review-arr", "photo-arr"])])) : createCommentVNode("", true), _ctx.syndicated ? (openBlock(), createElementBlock("section", _hoisted_12, [_ctx.syndicationDetails !== void 0 ? (openBlock(), createElementBlock("div", _hoisted_13, [createVNode(unref(ProductReviewsSyndicatedBadge), normalizeProps(guardReactiveProps(_ctx.syndicationDetails)), null, 16)])) : createCommentVNode("", true), (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.clientResponses, (response) => {
        return openBlock(), createElementBlock("div", {
          key: response.Date,
          class: "individual-review__client-response"
        }, [createVNode(unref(ProductReviewsSyndicatedResponse), mergeProps({
          ref_for: true
        }, response, {
          "publish-date": response.publishTime
        }), null, 16, ["publish-date"])]);
      }), 128))])) : createCommentVNode("", true)], 2), _ctx.secondaryRatingsOrder.length > 0 ? (openBlock(), createElementBlock("section", {
        key: 0,
        class: normalizeClass(["individual-review__customer-rating", _ctx.isModal && " individual-review__customer-rating--modal"])
      }, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.secondaryRatingsOrder, (section) => {
        return openBlock(), createBlock(unref(ProductReviewsAverageRatingBar), {
          key: section,
          id: _ctx.secondaryRatings[section].Id,
          class: "individual-review__secondary-review",
          "average-rating": _ctx.secondaryRatings[section].Value,
          "value-range": _ctx.secondaryRatings[section].ValueRange,
          "max-label": _ctx.secondaryRatings[section].MaxLabel,
          "min-label": _ctx.secondaryRatings[section].MinLabel,
          label: _ctx.secondaryRatings[section].Label
        }, null, 8, ["id", "average-rating", "value-range", "max-label", "min-label", "label"]);
      }), 128))], 2)) : createCommentVNode("", true), !_ctx.syndicated ? (openBlock(), createElementBlock("section", {
        key: 1,
        class: normalizeClass(["individual-review__helpful-reporting", "individual-review__text--200", _ctx.isModal && "individual-review__helpful-reporting--modal"]),
        "data-ui": "individual-review-helpful-section"
      }, [_cache[5] || (_cache[5] = createElementVNode("span", null, "Helpful?", -1)), createElementVNode("button", {
        class: normalizeClass(["individual-review__helpful-button", helpfulValue.value === 0 && "individual-review__helpful-button--clicked"]),
        "data-ui": "individual-review-helpful-button",
        disabled: helpfulValue.value !== 2,
        "aria-label": "Vote this review as helpful",
        onClick: _cache[1] || (_cache[1] = ($event) => onHelpfulVoteClick(true))
      }, [createVNode(unref(IconThumbsUp)), createElementVNode("span", null, toDisplayString(_ctx.totalPositiveFeedbackCount + (helpfulValue.value === 0 ? 1 : 0)), 1)], 10, _hoisted_14), createElementVNode("button", {
        class: normalizeClass(["individual-review__helpful-button--negative", helpfulValue.value === 1 && "individual-review__helpful-button--clicked"]),
        "data-ui": "individual-review-not-helpful-button",
        disabled: helpfulValue.value !== 2,
        "aria-label": "Vote this review as unhelpful",
        onClick: _cache[2] || (_cache[2] = ($event) => onHelpfulVoteClick(false))
      }, [createVNode(unref(IconThumbsUp)), createElementVNode("span", null, toDisplayString(_ctx.totalNegativeFeedbackCount + (helpfulValue.value === 1 ? 1 : 0)), 1)], 10, _hoisted_15), createElementVNode("button", {
        class: "individual-review__report-button",
        "data-ui": "individual-review-report-button",
        disabled: reportedAsInappropriate.value,
        onClick: onReported
      }, toDisplayString(reportedAsInappropriate.value ? "Reported" : "Report as inappropriate"), 9, _hoisted_16)], 2)) : createCommentVNode("", true)], 2);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=ProductReviewsIndividualReview2.mjs.map
